export default "__VITE_ASSET__C8NGVX5$__"